export type CompanyAreaId =
  | 'Commercial'
  | 'Operations'
  | 'Marketing'
  | 'People'
  | 'CustomerSuccess'
  | 'Relationship'
  | 'Technology';

export type CompanyAreaConfig = {
  id: CompanyAreaId;
  label: string;
};

export const COMPANY_AREAS: CompanyAreaConfig[] = [
  { id: 'Commercial', label: 'Comercial' },
  { id: 'Operations', label: 'Operações' },
  { id: 'Marketing', label: 'Marketing' },
  { id: 'People', label: 'Pessoas' },
  { id: 'CustomerSuccess', label: 'Sucesso do cliente' },
  { id: 'Relationship', label: 'Relacionamento' },
  { id: 'Technology', label: 'Tecnologia' },
];

export const DEFAULT_COMPANY_AREA: CompanyAreaId = 'Technology';

export function formatCompanyArea(area: string): string {
  return COMPANY_AREAS.find((item) => item.id === area)?.label ?? area;
}

export function isCompanyAreaId(value: string): value is CompanyAreaId {
  return COMPANY_AREAS.some((item) => item.id === value);
}
